import React from 'react'
import { Col, Container, Form, InputGroup, Row } from 'react-bootstrap'
import { Button } from '../../../components/Button/Button'
import { Plan } from '../../../models/Plan'

interface SeatUpgradeBodyProps {
  numberOfSeats: number | null
  onNumberOfSeatsChange: (newSeats: number) => void
  customerPlan: Plan | null
  floorHint?: string | null
}

export const SeatUpgradeBody: React.FC<SeatUpgradeBodyProps> = ({ numberOfSeats, onNumberOfSeatsChange, customerPlan, floorHint = null }) => {
  const FreePlanWarning = () => (
    <>
      <Container>
        <Row className='zocks-bg-color-primary-light justify-content-center rounded'>
          <Col className='d-flex align-items-center gap-3  align-self-center'>
            <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
            <div className='py-2'>
              <span className='zocks-text-gray-900'>Please start a free trial or upgrade your plan before adding more seats.</span>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )

  return (
    <Container className='p-0'>
      <Row>
        <Col>
          <Form.Label>Number of seats</Form.Label>
          {customerPlan && customerPlan.type === 'free' ? (
            <FreePlanWarning />
          ) : (
            <>
              <InputGroup className='d-flex gap-2'>
                <Form.Control
                  placeholder='Number of seats'
                  type='number'
                  min={0}
                  value={numberOfSeats || 0}
                  isInvalid={!!floorHint}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => onNumberOfSeatsChange(e.currentTarget.valueAsNumber)}
                />
                <div className='d-flex gap-2'>
                  <Button variant='primary' className='py-1 px-2' onClick={() => onNumberOfSeatsChange(numberOfSeats ? numberOfSeats - 1 : 0)}>
                    <i className='bi bi-dash'></i>
                  </Button>
                  <Button variant='primary' className='py-1 px-2' onClick={() => onNumberOfSeatsChange(numberOfSeats ? numberOfSeats + 1 : 1)}>
                    <i className='bi bi-plus'></i>
                  </Button>
                </div>
              </InputGroup>
              {floorHint ? (
                <Form.Text className='text-danger d-flex align-items-center gap-1'>
                  <i className='bi bi-exclamation-circle' />
                  {floorHint}
                </Form.Text>
              ) : null}
            </>
          )}
        </Col>
      </Row>
    </Container>
  )
}
